// helpers
import "./helpers/index.js";

// components
import "./components/menu.js";
import "./components/accordion.js";
import "./components/back-to-top.js";
import "./components/education-filter.js";
import "./components/swiper.js";
import "./components/notification.js";
import "./components/canon.js";
import "./components/animate-cards.js";
import "./components/animate-tabs.js";
import "./components/animate-titles.js";
import "./components/modal.js";
import "./components/order-pioniers.js";
import "./components/inhoudsopgave.js";
import "./components/audio-player.js";
